import { Col } from 'react-bootstrap';

import Avatar from '@website/components/directoryTheme/Avatar';
import { UserBookingDetailsQuery } from '@website/types/graphqlOperations';

type Props = {
  host: Pick<
    UserBookingDetailsQuery['booking']['trip']['host'],
    'logo' | 'team' | 'name'
  >;
};

export default function HostAndTeamAvatar({ host }: Props) {
  const isHostLogoSet = !!host.logo?.file?.key;

  return (
    <Col xs={12} md="auto" className="d-flex p-2">
      {/* hide avatar for host if not set */}
      {isHostLogoSet && (
        <Avatar
          size="xl"
          image={host.logo?.file?.key}
          defaultImageText={host.name}
          border
          alt={host.name}
        />
      )}
      {host.team.items.slice(0, 2).map((team, index) => (
        <div
          key={team?.givenName}
          style={{
            // Add marginLeft is host image shown or the image is the second one
            ...((isHostLogoSet || index > 0) && { marginLeft: '-25px' }),
          }}
        >
          <Avatar
            size="xl"
            image={team.picture?.file?.key}
            defaultImageText={team?.givenName}
            border
            alt={team?.givenName}
          />
        </div>
      ))}
    </Col>
  );
}
